import { useState ,useEffect} from "react";
import { useRef } from "react";
import {
  Box,
  Button,
  Container,
  Typography,
  TextField,
  InputLabel,
  Stack,
} from "@mui/material";
import ShapeSelector from "../components/ShapeSelector";
import ShapeSizeInput from "../components/ShapeSizeInput";
import ImageUploadPreviewModal from "../components/ImageUploadPreviewModal";

function HomePage() {
  const [image, setImage] = useState(null);
  const [pinCount, setPinCount] = useState(300);
  const [selectedShape, setSelectedShape] = useState("circle");
  const [boardSize, setBoardSize] = useState(60); // cm
  const [threadSize, setThreadSize] = useState(0.11); // mm
  const [maxLines, setMaxLines] = useState(10000); // optional

  const [shapeParams, setShapeParams] = useState({});
  const [openPreview, setOpenPreview] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  //  const [previewData, setPreviewData] = useState(null);

  const fileInputRef = useRef();

  useEffect(() => {
  fetch("/api/stats/visit", { method: "POST" }).catch(() => {});
}, []);


  return (
    <>
    <Stack
  direction="row"
  //alignItems="center"
  spacing={0}
  ml={2}
  
  mt={6}
  sx={{ mt: 1 }}
>
  <Box
    component="img"
    src="/logo.png"
    alt="Logo"
    sx={{ width: 40, height:40 }}
  />
  <Typography variant="h5" fontWeight="bold" marginTop={1.1} >Path</Typography>
</Stack>
    <Container maxWidth="sm" sx={{ py: 2 }}>
      

      {/* Header */}
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        String Art Generator
      </Typography>

      {/* Image Banner */}
      <Box
        position="relative"
        sx={{
          width: "100%",
          height: { xs: "40vh", md: "60vh" },
          backgroundImage: "url(/bruce_lee.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: 2,
          overflow: "hidden",
          mt: 2,
        }}
      >
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          bgcolor="rgba(0,0,0,0.4)"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Typography
            variant="h5"
            md={{ variant: "h3" }}
            color="white"
            textAlign="center"
            fontWeight="bold"
          >
            Turn Your Photo into Thread Art
          </Typography>
        </Box>
      </Box>

      <ShapeSelector
        selectedShape={selectedShape}
        setSelectedShape={setSelectedShape}
      />

      <Box>
        <TextField
          label="Board Size (cm)"
          type="number"
          fullWidth
          value={boardSize}
          onChange={(e) => setBoardSize(e.target.value)}
          variant="outlined"
          sx={{ mt: 2 }}
        />
        <TextField
          label="Number of Pins"
          type="number"
          fullWidth
          value={pinCount}
          onChange={(e) => setPinCount(e.target.value)}
          variant="outlined"
          sx={{ mt: 2 }}
        />

        <TextField
          label="Thread Thickness (mm)"
          type="number"
          fullWidth
          value={threadSize}
          onChange={(e) => setThreadSize(e.target.value)}
          variant="outlined"
          sx={{ mt: 2 }}
        />

        <TextField
          label="Maximum Lines"
          type="number"
          fullWidth
          value={maxLines}
          onChange={(e) => setMaxLines(e.target.value)}
          variant="outlined"
          sx={{ mt: 2 }}
        />
      </Box>
      <ImageUploadPreviewModal
        open={openPreview}
        onClose={() => {
          setOpenPreview(false);
          setImageFile(null);
          if (fileInputRef.current) fileInputRef.current.value = ""; // 👈 clear input
        }}
        imageFile={imageFile}
        selectedShape={selectedShape}
        boardSize={boardSize}
        threadSize={threadSize}
        maxLines={maxLines}
        pinCount={pinCount}
        shapeParams={shapeParams}
        // onGenerate={handleGenerate}
      />

      {/* Form Inputs */}
      <Stack spacing={3} mt={2}>
        {/* Image Upload */}
        <Box>
          <InputLabel shrink htmlFor="upload-image">
            Upload Image
          </InputLabel>

          <input
            ref={fileInputRef}
            type="file"
            id="upload-image"
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) {
                setImage(file);
                setImageFile(file);
                setOpenPreview(true);
              }
            }}
            style={{
              marginTop: "8px",
              padding: "8px 16px",
              borderRadius: "24px",
              backgroundColor: "black",
              color: "white",
              cursor: "pointer",
            }}
          />
        </Box>
      </Stack>
    </Container>
    </>
  );
}

export default HomePage;
